import { Box, Button, Grid, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { InputMask, Modal } from "src/components";
import { Save as SaveIcon, Cancel as CancelIcon } from "@material-ui/icons";
import { enviarPresente } from "src/store/actions/cashback";
import { useDispatch, useSelector } from "react-redux";
import { loadRankingAniversariantes } from "src/store/actions/fidelidade_resumo";

const PRESENTE_SCHEMA = {
  cliente_id: 0,
  empresa_id: 0,
  maximo_dias: 0,
  qtde_dias: 0,
  valor_cash: 0,
  usuario_nome: "",
  descricao: "",
  senha_liberacao: "",
  descricao: "",
};

function ModalCashbackPresente({ open, close, usuario }) {
  const [presenteForm, setPresenteForm] = useState(PRESENTE_SCHEMA);

  const dispatch = useDispatch();
  const { empresa_atual } = useSelector((state) => state.usuario);

  useEffect(() => {
    if (!usuario) return;

    setPresenteForm({
      ...PRESENTE_SCHEMA,
      usuario_nome: usuario.nome,
      cliente_id: usuario.id,
      empresa_id: empresa_atual.id,
    });
  }, [usuario, empresa_atual]);

  const handleChange = (event) => {
    setPresenteForm({
      ...presenteForm,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = () => {
    enviarPresente(presenteForm).then(() => {
      dispatch(loadRankingAniversariantes());
      close();
    });
  };

  return (
    <Modal open={open}>
      <Box display="flex" flexDirection="column" maxWidth="600px">
        <Typography style={{ marginBottom: "16px" }}>
          Enviar presente
        </Typography>
        <ValidatorForm onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item sm={12}>
              <TextValidator
                fullWidth
                disabled
                label="Nome do cliente"
                value={presenteForm.usuario_nome}
                variant="outlined"
              />
            </Grid>
            <Grid item sm={3}>
              <TextValidator
                fullWidth
                label="Máximo de dias"
                name="maximo_dias"
                onChange={handleChange}
                value={presenteForm.maximo_dias}
                variant="outlined"
              />
            </Grid>
            <Grid item sm={2}>
              <TextValidator
                fullWidth
                label="Validade"
                name="qtde_dias"
                onChange={handleChange}
                value={presenteForm.qtde_dias}
                variant="outlined"
              />
            </Grid>
            <Grid item sm={3}>
              <InputMask
                fullWidth
                label="Valor do presente"
                type="cash"
                name="valor_cash"
                value={presenteForm.valor_cash}
                onChange={(e) =>
                  setPresenteForm({
                    ...presenteForm,
                    valor_cash: e.target.values.floatValue,
                  })
                }
              />
            </Grid>
            <Grid item sm={4}>
              <TextValidator
                label="Senha de liberação"
                name="senha_liberacao"
                onChange={handleChange}
                value={presenteForm.senha_liberacao}
                variant="outlined"
              />
            </Grid>
            <Grid item sm={12}>
              <TextValidator
                fullWidth
                multiLine
                label="Descrição das regras"
                name="descricao"
                rows={2}
                rowsMax={2}
                value={presenteForm.descricao}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Box display="flex" marginTop="8px" justifyContent="flex-end">
            <Button type="submit" color="primary" size="small">
              {<SaveIcon />}&nbsp;Gravar
            </Button>
            <Button color="secondary" size="small" onClick={close}>
              {<CancelIcon />}&nbsp;Cancelar
            </Button>
          </Box>
        </ValidatorForm>
      </Box>
    </Modal>
  );
}

export default ModalCashbackPresente;
